"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startSpan = exports.connectLogsToSentry = void 0;
// Provide helpers to track performance spans through our internal logs
const logs_1 = require("@ledgerhq/logs");
function connectLogsToSentry(Sentry) {
    let apduSpan;
    const spans = {};
    return (0, logs_1.listen)(l => {
        var _a, _b;
        if (!l)
            return;
        if (l.type === "apdu") {
            if ((_a = l.message) === null || _a === void 0 ? void 0 : _a.startsWith("=>")) {
                const t = Sentry.getCurrentHub().getScope().getSpan();
                apduSpan = t === null || t === void 0 ? void 0 : t.startChild({
                    op: "apdu",
                    description: l.message.slice(0, 11),
                });
            }
            else if ((_b = l.message) === null || _b === void 0 ? void 0 : _b.startsWith("<=")) {
                apduSpan === null || apduSpan === void 0 ? void 0 : apduSpan.finish();
            }
        }
        else if (l.type === "perf-span") {
            const { data } = l;
            if (!data)
                return;
            const { id, starts, span } = data;
            if (starts) {
                const t = Sentry.getCurrentHub().getScope().getSpan();
                spans[id] = t === null || t === void 0 ? void 0 : t.startChild(Object.assign(Object.assign({}, span), { description: l.message || "" }));
            }
            else {
                const span = spans[id];
                span === null || span === void 0 ? void 0 : span.finish();
            }
        }
    });
}
exports.connectLogsToSentry = connectLogsToSentry;
let idCounter = 0;
function startSpan(op, description, rest) {
    let id = ++idCounter;
    const span = Object.assign({ op }, rest);
    (0, logs_1.log)("perf-span", description || "", {
        id,
        starts: true,
        span,
    });
    return {
        finish: () => {
            if (!id)
                return;
            (0, logs_1.log)("perf-span", description || "", { id });
            id = 0;
        },
    };
}
exports.startSpan = startSpan;
//# sourceMappingURL=performance.js.map